import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  documentType: {
    name: '',
    code: '',
    isActive: true,
  },
};

export const createDocumentType = createSlice({
  name: 'createDocumentType',
  initialState,
  reducers: {
    updateDocumentTypeInfo: (state, action) => {
      state.documentType = action.payload;
    },
    updateDocumentTypeInfoField: (state, action) => {
      const { field, value } = action.payload;
      state.documentType[field] = value;
    },
    clearDocumentTypeInfo: (state) => {
      state.documentType = initialState.documentType;
    },
  },
});

export const documentTypeDetailSelector = (state) =>
  state.createDocumentType.documentType;
export const {
  updateDocumentTypeInfo,
  updateDocumentTypeInfoField,
  clearDocumentTypeInfo,
} = createDocumentType.actions;

export const createDocumentTypeReducer = createDocumentType.reducer;
export const createDocumentTypeReducerName = createDocumentType.name;

export default createDocumentType.reducer;
